/**
 * Returns a safe internal redirect target.
 *
 * A `returnTo` parameter comes from the URL and is therefore
 * attacker-controlled. Redirecting to it blindly turns the sign-in flow into
 * an open redirect: a link to
 * `glanzluxe.com/login?returnTo=https://evil.example` would carry a customer
 * from a genuine Glanz Luxe URL to a phishing page (§29).
 *
 * Only a same-site absolute path is accepted. `//evil.example` is rejected
 * explicitly — it starts with "/" but browsers treat it as protocol-relative
 * and navigate off-site.
 */
export function safeReturnPath(candidate: string | null, fallback: string): string {
  if (!candidate) {
    return fallback;
  }

  const isInternalPath =
    candidate.startsWith('/') && !candidate.startsWith('//') && !candidate.includes('\\');

  return isInternalPath ? candidate : fallback;
}
